module.exports = __webpack_public_path__ + "img/medicaid.9f61d724.png";